import axios from "axios";

export const API = process.env.REACT_APP_BACKEND_URL;

// Bearer tokens are persisted so the Studio works on split deployments where the
// site (expante.com) and API (Render) are on different domains and browsers block
// cross-site cookies. Same-origin deployments keep working via httpOnly cookies.
const AT_KEY = "expante_at";
const RT_KEY = "expante_rt";

export const tokenStore = {
  get at() {
    return localStorage.getItem(AT_KEY);
  },
  get rt() {
    return localStorage.getItem(RT_KEY);
  },
  set(at, rt) {
    if (at) localStorage.setItem(AT_KEY, at);
    if (rt) localStorage.setItem(RT_KEY, rt);
  },
  clear() {
    localStorage.removeItem(AT_KEY);
    localStorage.removeItem(RT_KEY);
  },
};

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = tokenStore.at;
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const config = error.config || {};
    const url = config.url || "";
    if (error.response?.status === 401 && !config._retry && !url.includes("/api/auth/")) {
      config._retry = true;
      try {
        refreshing =
          refreshing ||
          api
            .post("/api/auth/refresh", { refresh_token: tokenStore.rt || undefined })
            .then((r) => {
              if (r.data?.access_token) tokenStore.set(r.data.access_token, null);
            })
            .finally(() => {
              refreshing = null;
            });
        await refreshing;
        return api(config);
      } catch (e) {
        tokenStore.clear();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(error, fallback = "Something went wrong. Please try again.") {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
}

export const fileUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("/") || path.startsWith("http")) return path; // baked/self-hosted or Cloudinary URL
  return `${API}/api/files/${path}`;
};

export const readTime = (html) => {
  const words = (html || "").replace(/<[^>]*>/g, " ").split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};
